var styles = {
  "Toolbar": "Online-Store-UI-Toolbar_qtg83",
  "Group": "Online-Store-UI-Toolbar__Group_16m32",
  "Section": "Online-Store-UI-Toolbar__Section_54u0f"
};

export { styles as default };
